
import { Component, Prop, Vue } from 'vue-property-decorator';
import { MonthPicker } from 'vue-month-picker';

@Component({
  components: {
    MonthPicker
  }
})
export default class DateRangePicker extends Vue {
  @Prop({ required: true }) value!: any;
  @Prop({ type: String, default: 'Rango' }) label!: string;

  menu = false;

  isMonthSelected(index: number) {
    return index >= this.value.from && index <= this.value.to;
  }

  setMonth(index: number) {
    this.$emit('set-month', index);
  }
}
